import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL

export default class Domain {
  constructor(token) {
    axios.defaults.baseURL = API_URL + '/v1/domains'
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  }

  getMySiteInfo() {
    return axios
      .get('/mysite')
      .then((response) => response.data)
      .catch(() => false)
  }

  getAvailability(domain) {
    return axios
      .get('/availability', { params: { domain } })
      .then((response) => response.data)
  }

  addSolicitation(solicitation) {
    return axios
      .post('/solicitations', {
        domain: solicitation.domain,
        wedsite_id: solicitation.wedsite_id,
      })
      .then((response) => response.data)
      .catch((error) => error.response)
  }

  cancelSolicitation(id) {
    return axios
      .put(`/solicitations/${id}/status`, {
        action: 'cancel',
      })
      .then((response) => response.data)
      .catch((error) => error.response)
  }
}
